import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class UpdateUserArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  input: Record<string, any>

  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<User>
}

export interface IUpdateUser extends IAction<User, UpdateUserArgs> {}
